"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACKING_STAGES = void 0;
exports.trackingStage = trackingStage;
exports.etaWindow = etaWindow;
exports.TRACKING_STAGES = ['PREPARING', 'OUT_FOR_DELIVERY', 'ON_THE_WAY', 'DELIVERED', 'PART_DELIVERED', 'ATTEMPTED', 'RETURNING', 'CONTACT_MERCHANT'];
const STAGE = {
    CREATED: 'PREPARING',
    COLLECTED: 'PREPARING',
    RECEIVED_AT_HUB: 'PREPARING',
    IN_HUB_TRANSFER: 'PREPARING',
    ON_HOLD: 'PREPARING',
    ASSIGNED: 'PREPARING',
    RESCHEDULED: 'PREPARING',
    OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
    // the courier is heading to this customer now
    IN_TRANSIT: 'ON_THE_WAY',
    DELIVERED: 'DELIVERED',
    // the payment link is Blink's matter, not the customer's: the parcel is delivered
    DELIVERED_LINK_PENDING: 'DELIVERED',
    PARTIALLY_DELIVERED: 'PART_DELIVERED',
    FAILED: 'ATTEMPTED',
    RTO: 'RETURNING',
    RETURNED_TO_CLIENT: 'RETURNING',
    // internal problems are never shown to the customer
    CANCELLED: 'CONTACT_MERCHANT',
    MISSING: 'CONTACT_MERCHANT',
    DAMAGED_LOST: 'CONTACT_MERCHANT',
};
function trackingStage(status) {
    return STAGE[status];
}
const HALF_HOUR = 30 * 60_000;
/**
 * The arrival window shown to the customer: from 30 minutes before the planned arrival to 30
 * minutes after, on half hours (about 1 to 1½ hours wide), never starting in the past. A planned
 * arrival already passed gives no window: the page then says "later today".
 */
function etaWindow(eta, now = new Date()) {
    const at = new Date(eta).getTime();
    if (Number.isNaN(at) || at < now.getTime())
        return null;
    const floor = (t) => Math.floor(t / HALF_HOUR) * HALF_HOUR;
    const ceil = (t) => Math.ceil(t / HALF_HOUR) * HALF_HOUR;
    const from = Math.max(floor(at - HALF_HOUR), floor(now.getTime()));
    return { from: new Date(from), to: new Date(Math.max(ceil(at + HALF_HOUR), from + HALF_HOUR)) };
}
//# sourceMappingURL=tracking.js.map